<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-content">
        <div class="login-title">消息中心平台</div>
        <el-form ref="loginForm" :model="form" :rules="rules" label-width="0">
          <el-form-item prop="account">
            <el-input
              v-model.trim="form.account"
              placeholder="请输入账号"
              clearable
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model.trim="form.password"
              type="password"
              placeholder="请输入密码"
              show-password
              @keyup.enter.native="handleSubmit"
            />
          </el-form-item>
          <div class="login-actions">
            <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
          </div>
          <el-button
            type="primary"
            :loading="loading"
            class="login-btn"
            @click="handleSubmit"
          >
            登录
          </el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    const loginInfo = this.$store.state.request.loginUserInfo || {};
    return {
      loading: false,
      form: {
        account: loginInfo.account || "",
        password: loginInfo.rememberPassword ? loginInfo.password || "" : "",
      },
      rememberPassword: !!loginInfo.rememberPassword,
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          await this.$store.dispatch("loginByAccount", {
            account: this.form.account,
            password: this.form.password,
          });
          this.$store.dispatch("rememberLoginInfo", {
            account: this.rememberPassword ? this.form.account : "",
            password: this.rememberPassword ? this.form.password : "",
            rememberPassword: this.rememberPassword,
          });
          this.$router.replace("/");
        } catch (error) {
          console.log("登录失败");
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #e0e7ff 0%, #f8fafc 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  display: flex;
  min-height: 500px;
  width: 900px;
  max-width: 96vw;
  border-radius: 18px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
  background: #fff;
  position: relative;
  overflow: hidden;
  margin: 40px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-content {
  width: 320px;
}

.login-title {
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
  color: #1d2129;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
}

.login-actions {
  margin-bottom: 14px;
}

.login-btn {
  width: 100%;
}
</style>
